import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const renderComponent = (params: string) => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App query={params}/>
    </React.StrictMode>
  );
};

// Объявляем свойство 'orders' на объекте window
declare global {
  interface Window {
    orders: { renderComponent: (params: string) => void };
  }
}

// renderComponent("competitions_api/orders?compensation_type=1");
window.orders = { renderComponent };